export { Badge } from './Badge';
export type { BadgeProps } from './Badge';
export * from '@mui/joy/Badge';
